import React from 'react';
import { Link } from 'react-router-dom';

export type ClientListItem = {
  id: number;
  name: string;
  curator: string;
  fieldOfActivity: string;
  projects: number;
  cases: number;
  tasks: number;
};

type ClientsMobileListProps = {
  clients: ClientListItem[];
  loading?: boolean;
  errorMessage?: string | null;
  skeletonCount?: number;
};

const ClientsMobileList: React.FC<ClientsMobileListProps> = ({
  clients,
  loading = false,
  errorMessage = null,
  skeletonCount = 6,
}) => {
  if (loading) {
    return (
      <ul className="clients-mobile-list" aria-busy="true" aria-label="Загрузка списка клиентов">
        {Array.from({ length: skeletonCount }).map((_, idx) => (
          <li key={idx} className="clients-card clients-card--skeleton" aria-hidden="true">
            <div className="clients-skeleton-line clients-card-skeleton-title" />
            <div className="clients-card-meta">
              <div className="clients-skeleton-line" />
              <div className="clients-skeleton-line" />
            </div>
            <div className="clients-card-metrics">
              <div className="clients-skeleton-line clients-card-skeleton-metric" />
              <div className="clients-skeleton-line clients-card-skeleton-metric" />
              <div className="clients-skeleton-line clients-card-skeleton-metric" />
            </div>
          </li>
        ))}
      </ul>
    );
  }

  if (errorMessage) {
    return (
      <div className="clients-mobile-list clients-mobile-list--message clients-mobile-list--error" role="alert">
        {errorMessage}
      </div>
    );
  }

  if (clients.length === 0) {
    return <div className="clients-mobile-list clients-mobile-list--message">Нет данных для отображения</div>;
  }

  return (
    <ul className="clients-mobile-list">
      {clients.map((client) => (
        <li key={client.id}>
          <Link to={`/clients/${client.id}`} className="clients-card" aria-label={`Клиент ${client.name}`}>
            <h3 className="clients-card-name">{client.name}</h3>
            <div className="clients-card-meta">
              <div className="clients-card-field">
                <span className="clients-card-label">Куратор</span>
                <span className="clients-card-value">{client.curator || '—'}</span>
              </div>
              <div className="clients-card-field clients-card-field--full">
                <span className="clients-card-label">Сфера деятельности</span>
                <span className="clients-card-value">{client.fieldOfActivity || '—'}</span>
              </div>
            </div>
            <div className="clients-card-metrics" aria-label="Активные проекты, дела и задачи">
              <span className="clients-card-metric">
                <b>{client.projects}</b>
                проектов
              </span>
              <span className="clients-card-metric">
                <b>{client.cases}</b>
                дел
              </span>
              <span className="clients-card-metric">
                <b>{client.tasks}</b>
                задач
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default ClientsMobileList;
